import ko from "lib/knockout";
import _ from "lib/underscore";
import {List, ListItem} from "./lists";
import * as urlUtils from "../../../../core/utils/url";
import {asNumber} from "../../../../core/utils/var";
import {settings} from "../data";
import {lang} from "../../../../core/utils/lang";

export class Factory {
	newCategoryItem(itemData) {
		if (itemData.id == 0) {
			return new FakeCategoryItem(itemData);
		}
		return new CategoryItem(itemData);
	}
}

export class BaseCategoryList extends List {
	_selected = ko.pureComputed(() => _.first(this.selectedItems));
	_sortType = ko.observable();

	constructor(data = null) {
		super({name: 'categories', title: lang('shop_filter_category'), ...data});

		this._groupedItems = ko.pureComputed(() => {
			const groupedItems = {};
			const groupsIndex = {};
			this.visibleItems.forEach(item => {
				/** @type {BaseCategoryItem} */
				const cat = item;
				if (cat.groups) {
					cat.groups.forEach(cg => {
						if (!groupedItems[cg.id]) {
							groupedItems[cg.id] = [];
							groupsIndex[cg.id] = cg;
						}
						groupedItems[cg.id].push(cat);
					})
				} else {
					/*if (!groupedItems[0]) {
						groupedItems[0] = [];
						groupsIndex[0] = new CategoryGroup({id:0, name: 'nogroup', title: 'Без группы', order: Number.MAX_VALUE});
					}
					groupedItems[0].push(cat);*/
				}
			});

			const arr = [];
			_.map(groupedItems, (items, groupId) => {
				const group = groupsIndex[groupId];
				arr.push({
					group,
					items
				})
			});
			return _.sortBy(arr, item => item.group.order);
		});
	}

	/**
	 * @return {T}
	 */
	get selected() {
		return this._selected();
	}

	/**
	 *
	 * @return {array}
	 */
	get groupedItems() {
		return this._groupedItems();
	}

	get sortType() {
		return this._sortType();
	}

	set sortType(value) {
		this._sortType(value);
	}

	/**
	 * @param {BaseCategoryItem} item1
	 * @param {BaseCategoryItem} item2
	 * @return {number}
	 */
	sortFunction(item1, item2) {
		// default is "by order ascending"
		const order = item1.order - item2.order;
		if (this.sortType === 'count') {
			const orderByCount = item2.count - item1.count;
			return orderByCount !== 0 ? orderByCount : order;
		} else {
			return order;
		}
	}
}

export class CategoryList extends BaseCategoryList {
	_allItemsIndex = ko.observable({});
	_categoryGroupsIndex = ko.observable();
	_activeItem = ko.observable();

	constructor(data = null) {
		super({name: 'categories', title: 'Категория', ...data});

		// fix context for methods that are used in knockout bindings
		this.handleMouseOver = this.handleMouseOver.bind(this);

		this._activeItemComputed = ko.pureComputed(() => {
		    const item = this._activeItem();
		    if (item && _.contains(this.visibleItems, item)) {
		    	return item;
		    } else {
			    return _.first(this.visibleItems)
		    }
		});
	}

	/**
	 *
	 * @param data
	 * @param categoryGroups
	 * @return {*}
	 */
	init(data, categoryGroups) {
		if (categoryGroups) {
			const categoryGroupsIndex = {};
			categoryGroups.map(item => {
				const cg = new CategoryGroup(item);
				categoryGroupsIndex[cg.id] = cg;
				return cg;
			});
			this._categoryGroupsIndex(categoryGroupsIndex);
		} else {
			this._categoryGroupsIndex(null);
		}

		super.init(data);
	}

	initItems(itemsData) {
		super.initItems(itemsData);

		const allItems = {};
		this.items.forEach(item => {
			/** @type {CategoryItem} */
			const cat = item;
			allItems[cat.id] = cat;
			cat.subcategories.items.forEach(i => allItems[i.id] = i);
		});
		this._allItemsIndex(allItems);
	}

	newItem(itemData) {
		const d = {
			...itemData,
			url: settings.getCategoryUrl(itemData.name),
			groups: itemData.group_ids && this._categoryGroupsIndex() ? _.map(itemData.group_ids, id => this._categoryGroupsIndex()[id]) : null
		};

		let cat;
		if (d.id == 0) {
			cat = new FakeCategoryItem(d);
		} else {
			cat = new CategoryItem(d);
		}
		let subcatData;
		if (d.subcategories) {
			subcatData = _.map(d.subcategories, d => {
				const groups = d.group_ids && this._categoryGroupsIndex() ? _.map(d.group_ids, id => this._categoryGroupsIndex()[id]) : null;
				return {
					...d,
					groups: groups
				}
			});
		}
		cat.subcategories = this.newSubcategoryList(subcatData, cat);
		if (subcatData) {
			cat.subcategories.init(subcatData);
			cat.subcategories.onItemClick(item => this.handleClick(item));
		}
		return cat;
	}

	newSubcategoryList(data, category) {
		return new SubcategoryList(data, category, this);
	}

	resetCounts() {
		_.each(this.items, (item) => {
			item.count = 0;
			item.subcategories.resetCounts();
		})
	}

	updateCounts(data) {
		_.each(this._allItemsIndex(), item => {
			item.count = data ? asNumber(data[item.id]) : 0;
		});
	}

	/**
	 * Returns ether category or subcategory by ID
	 * @param {number} id
	 * @return {CategoryItem|SubcategoryItem}
	 */
	getAnyItem(id) {
		return this._allItemsIndex()[id];
	}

	get activeItem() {
		return this._activeItemComputed();
	}

	/**
	 * @param {CategoryItem} item
	 */
	handleMouseOver(item) {
		this._activeItem(item);
	}

    /**
	 * Force subcategories panel to repaint itself
	 * (Fix for strange bug introduced in the last Chrome update)
     */
	refresh() {
		const active = this._activeItem();
        this._activeItem(null);
        this._activeItem(active);
    }

}

export class SubcategoryList extends BaseCategoryList {
	/**
	 * @param {object} data
	 * @param {CategoryItem} category
	 * @param {CategoryList} categoryList
	 */
	constructor(data, category, categoryList) {
		super({name: 'subcategories', title: 'Категория', ...data});
		this._category = category;
		this._categoryList = categoryList;
	}

	newItem(itemData) {
		const d = {
			...itemData,
			url: settings.getCategoryUrl(this._category.name, itemData.name)
		};
		return new SubcategoryItem(d, this._category);
	}

	get sortType() {
		// use the same as category list
		return this._categoryList.sortType;
	}

    get category() {
        return this._category;
    }
}

export class BaseCategoryItem extends ListItem {
	constructor(data) {
		super(data);
		this._url = data.url;
		this._order = data.order || 0;
		this._groups = data.groups;
	}

	/**
	 * @return {string}
	 */
	get url() {
		return this._url;
	}

	/**
	 * @return {number}
	 */
	get order() {
		return this._order;
	}

	/**
	 * @return {CategoryGroup[]}
	 */
	get groups() {
		return this._groups;
	}

	get disabled() {
		return this.count == 0;
	}
}

export class CategoryItem extends BaseCategoryItem {
	_subcategories = ko.observable();
	_popularShops = [];

	constructor(data) {
		super(data);
		this._subcategoriesCountSum = ko.pureComputed(() => {
			let sum = 0;
			this.subcategories.items.forEach(s => sum += s.count);
			return sum;
		});
		if(!_.isUndefined(data.popular_shops)) {
			this._popularShops = _.map(data.popular_shops, s => new PopularShopItem(s, this));
		}
	}

	get count() {
		return this._subcategoriesCountSum();
	}

	set count(value) {
		// do nothing
	}

	/**
	 * @return {SubcategoryList}
	 */
	get subcategories() {
		return this._subcategories();
	}

	/**
	 * @param {SubcategoryList} value
	 */
	set subcategories(value) {
		this._subcategories(value);
	}

	/** @type {PopularShopItem[]} */
    get popularShops() {
        return this._popularShops;
    }
}

export class SubcategoryItem extends BaseCategoryItem {
	/**
	 * @param {object} data
	 * @param {CategoryItem} category
	 */
	constructor(data, category) {
		super(data);
		this._category = category;
	}

	/**
	 * @return {CategoryItem}
	 */
	get category() {
		return this._category;
	}
}

export class FakeCategoryItem extends CategoryItem {
	constructor(data) {
		super(data);
	}

	get count() {
		return this._count();
	}

	set count(value) {
		this._count(value);
	}

	get order() {
		return Number.MAX_VALUE;
	}
}

export class CategoryGroup {
	constructor(data) {
		this._id = data.id;
		this._name = data.name;
		this._title = data.title;
		this._order = data.order;
	}

	get id() {
		return this._id;
	}

	get name() {
		return this._name;
	}

	get title() {
		return this._title;
	}

	get order() {
		return this._order;
	}
}

export class PopularShopItem {
	/**
	 * @param {object} data
	 * @param {CategoryItem} category
	 */
	constructor(data, category) {
		this._id = +data.id;
		this._title = data.title;
		this._logo = data.logo;
		this._url = data.url || urlUtils.joinPath(category.url, {shop: data.id});
		this._category = category;
	}

	/** @return {number} */
	get id() {
		return this._id;
	}

	/** @return {string} */
	get title() {
		return this._title;
	}

	/** @return {string} */
	get logo() {
		return this._logo;
	}

	/** @return {string} */
	get url() {
		return this._url;
	}

	/** @return {CategoryItem} */
	get category() {
		return this._category;
	}
}


// WEBPACK FOOTER //
// ./modules/shop/common/model/categories.js